import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, ms: number): T {
	const [settled, setSettled] = useState(value);
	useEffect(() => {
		const t = window.setTimeout(() => setSettled(value), ms);
		return () => window.clearTimeout(t);
	}, [value, ms]);
	return settled;
}
